module.exports = __webpack_public_path__ + "static/media/doc_containing_video.d85a924b.svg";